'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import unescapedText from 'I18n/utils/unescapedText';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import MobilePanelNavItem from 'ecosystem-marketplace-core/js/components/mobile/MobilePanelNavItem';
import MobilePanel from 'ecosystem-marketplace-core/js/components/mobile/MobilePanel';
import MobileFilterDrilldownWrapper from './MobileFilterDrilldownWrapper';
import { getTranslatedSortText } from '../../../../utils/i18n';
import * as SortFields from '../../../../constants/search/SortField';
import * as SortOrders from '../../../../constants/search/SortOrder';
const PANEL_KEY = 'sort';

const MobileSortPanel = ({
  activePanelIds,
  activeSort,
  activeOrder,
  applyFilters,
  clickFilter,
  closePanel,
  onSortChange,
  searchTerm,
  pricingSortEnabled
}) => {
  const renderedSortOptions = useMemo(() => {
    const sortOptions = [];
    const sortFields = Object.values(SortFields);
    const sortOrders = Object.values(SortOrders);
    sortFields.forEach(sort => {
      let previous;
      sortOrders.forEach(order => {
        const text = getTranslatedSortText(sort, order);

        if (text) {
          if (sort !== SortFields.RELEVANCE || searchTerm) {
            if (text === previous) {
              sortOptions.pop();
            }

            sortOptions.push({
              sort,
              order,
              text
            });
          }

          previous = text;
        }
      });
    });
    return sortOptions.map(sort => {
      return (sort.sort !== SortFields.PRICE || pricingSortEnabled) && /*#__PURE__*/_jsx(UIRadioInput, {
        name: sort.text,
        checked: activeSort === sort.sort && activeOrder === sort.order || activeSort === null && sort.sort === SortFields.HUB_INSTALLS,
        className: "m-bottom-2",
        onChange: ({
          target: {
            checked
          }
        }) => {
          if (checked) {
            onSortChange(sort.sort, sort.order);
          }
        },
        children: sort.text
      }, `${sort.sort}:${sort.order}`);
    });
  }, [activeOrder, activeSort, onSortChange, pricingSortEnabled, searchTerm]);
  const onPanelClose = useCallback(() => {
    closePanel(PANEL_KEY);
  }, [closePanel]);
  const open = activePanelIds && activePanelIds.indexOf(PANEL_KEY) !== -1;
  return /*#__PURE__*/_jsx(MobilePanelNavItem, {
    onClickItem: clickFilter,
    title: getTranslatedSortText(activeSort, activeOrder),
    itemId: PANEL_KEY,
    children: /*#__PURE__*/_jsx(MobilePanel, {
      open: open,
      align: "right",
      children: /*#__PURE__*/_jsx(MobileFilterDrilldownWrapper, {
        title: unescapedText('appMarketplace.storefront.results.sort.mobileLabel'),
        onPanelClose: onPanelClose,
        onPanelOpen: open,
        applyFilters: applyFilters,
        children: renderedSortOptions
      })
    })
  });
};

MobileSortPanel.propTypes = {
  activeOrder: PropTypes.string,
  activePanelIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeSort: PropTypes.string,
  applyFilters: PropTypes.func.isRequired,
  clickFilter: PropTypes.func.isRequired,
  closePanel: PropTypes.func.isRequired,
  onSortChange: PropTypes.func.isRequired,
  pricingSortEnabled: PropTypes.bool.isRequired,
  searchTerm: PropTypes.string.isRequired
};
export default MobileSortPanel;